import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';
import { getDefaultFiat } from '../utils/FiatUtils';
import { getCurrentEnvironment } from '../utils/CurrentEnvironmentStorage';

const EXCHANGE_URL = getBaseUrl('/exchange/');

// export const STOP_TYPES = ["STOP_LOSS", "STOP_LOSS_LIMIT", "TAKE_PROFIT", "TAKE_PROFIT_LIMIT"];
// export const FINISHED_STATUS = ["FILLED", "REJECTED", "CANCELED"];

export async function getBalance() {
    const env = getCurrentEnvironment();
    const query = env === 'test' ? '?environment=test' : '';
    return await appRequest.doGetRequest(`${EXCHANGE_URL}balance/${getDefaultFiat()}${query}`);
}

export async function getFullBalance(fiat) {
    const env = getCurrentEnvironment();
    const query = env === 'test' ? '?environment=test' : '';
    return await appRequest.doGetRequest(`${EXCHANGE_URL}balance/full/${fiat}${query}`);
}

export async function getCoins() {
    return await appRequest.doGetRequest(`${EXCHANGE_URL}coins`);
}

export async function getAccountInfo() {
    return await appRequest.doGetRequest(`${EXCHANGE_URL}account-info`);
}

export async function doWithdraw(withdrawTemplateId) {
    return await appRequest.doPostRequest(`${EXCHANGE_URL}withdraw/${withdrawTemplateId}`, null);
}

export async function doTestApiUrl(apiUrl, accessKey, secretKey) {
    const data = { apiUrl, accessKey, secretKey };
    return await appRequest.doPostRequest(`${EXCHANGE_URL}test-api-url`, data);
}

export async function doTestStreamUrl(streamUrl) {
    const data = { streamUrl };
    return await appRequest.doPostRequest(`${EXCHANGE_URL}test-stream-url`, data);
}

export async function getProviders() {
    return await appRequest.doGetRequest(`${EXCHANGE_URL}providers`);
}

